import React from 'react'
import { TextField, InputAdornment, IconButton } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import * as constants from '../../../shared/state/constants/appConstants'
import * as Icons from '@material-ui/icons'
import ButtonLoading from '../buttonLoading/buttonLoading'
import Button from '../../../shared/components/atoms/Button/Button'
import Icon from '../../../shared/components/atoms/Icon/Icon'
import {
	sessionStorage,
	localStorage,
} from './../../../shared/state/utils/storage'
import useSessionState from '../../../shared/hooks/useSessionState'
import './changePassword.scss'
import OTPService from '../../../shared/services/otp'
import SessionService from '../../../shared/services/session'
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase'

const ChangePassword = ({
	type,
	tempPass,
	setPasswordChanged,
	handlePrevSlider,
	handleNextSlider,
	passRef,
	setCurrentPayload,
	setOTPModalVisibility,
	setCurrentSlider,
	sliderRef,
}) => {
	const [values, setValues] = React.useState({
		first_password: '',
		second_password: '',
		show_firstPassword: false,
		show_secondPassword: false,
		passwords_equals: false,
		first_passwordErrorMsg: '',
		second_passwordErrorMsg: '',
	})
	const firstPass = React.useRef()
	const secondPass = React.useRef()
	const [isLoaderVisible, setLoaderVisible] = React.useState(false)

	const {
		register,
		handleSubmit,
		errors,
		triggerValidation,
		formState,
		getValues,
	} = useForm({})
	const { actualStorage } = useSessionState()
	const handleChange = props => event => {
		const data = getValues()
		triggerValidation({ name: event.target.name })
		if (event.target.name === 'password_two') {
			data.password_two === data.password_one
				? setValues({ ...values, passwords_equals: true })
				: setValues({ ...values, passwords_equals: false })
		}
	}

	const onSubmit = (data, e) => {
		// e.stopPropagation();
		setLoaderVisible(true)
		if (
			formState.isValid &&
			data.password_one &&
			data.password_two &&
			values.passwords_equals
		) {
			const tokenData =
				actualStorage === 0
					? localStorage.getItem('tokenData')
					: sessionStorage.getItem('tokenData')
			const email =
				actualStorage === 0
					? localStorage.getItem('userData')
					: sessionStorage.getItem('userData')
			const payload = {
				accessToken: tokenData.accessToken,
				previousPassword:
					type === 1
						? tempPass
						: passRef.current.children[1].childNodes[0].value,
				proposedPassword: data.password_two,
				email: email.email,
			}
			OTPService.getKey(SessionService.getIdTokenData())
				.then(() => {
					setOTPModalVisibility(true)
					setCurrentPayload(payload)
					if (type === 0) {
						setCurrentSlider(sliderRef)
					}
					setLoaderVisible(false)
				})
				.catch(err => {
					console.log(err)
					setLoaderVisible(false)
				})
		} else {
			setLoaderVisible(false)
		}
	}
	const handleClickShowPassword = passIndex => {
		passIndex === 1
			? setValues({ ...values, show_firstPassword: !values.show_firstPassword })
			: setValues({
					...values,
					show_secondPassword: !values.show_secondPassword,
			  })
	}
	const handleMouseDownPassword = event => {
		event.preventDefault()
	}
	return (
		<>
			<form
				id='form-password'
				className='f-form-password'
				onSubmit={handleSubmit(onSubmit)}
			>
				{type === 1 ? (
					<h1 className='f-h1'>CAMBIA TU CONTRASEÑA </h1>
				) : (
					<h3 className='f-modaltitle'>CAMBIAR CONTRASEÑA</h3>
				)}
				<p className='f-passchange-desc f-p'>
					Hemos recibido la solicitud para recuperar tu contraseña, por favor
					escribe tu nueva contraseña y haz clic en el botón “Cambiar
					contraseña”. Después de crear tu nueva contraseña puedes ingresar a tu
					cuenta en nuestro sitio Web.
				</p>
				<TextField
					error={errors.password_one != null}
					color='secondary'
					name='password_one'
					className='f-form-input'
					id='f-passwordone-input'
					variant='outlined'
					ref={firstPass}
					type={values.show_firstPassword ? 'text' : 'password'}
					onChange={handleChange()}
					label='Contraseña nueva'
					helperText={
						errors.password_one && errors.password_one.type === 'required'
							? 'Una contraseña es requerida'
							: errors.password_one && errors.password_one.type === 'minLength'
							? 'La contraseña debe contener mínimo 6 caracteres'
							: errors.password_one && errors.password_one.type === 'maxLength'
							? 'La contraseña no debe exceder los 40 caracteres'
							: ''
					}
					inputRef={register({
						required: true,
						minLength: constants.PASSWORD_MIN_LENGTH,
						maxLength: constants.PASSWORD_MAX_LENGTH,
					})}
					InputProps={{
						endAdornment: (
							<InputAdornment position='end'>
								<IconButton
									edge='end'
									aria-label='toggle password visibility'
									onClick={() => {
										handleClickShowPassword(1)
									}}
									onMouseDown={handleMouseDownPassword}
								>
									{values.show_firstPassword ? (
										<Icons.VisibilityOff className='f-btn-password' />
									) : (
										<Icons.Visibility className='f-btn-password' />
									)}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
				<p className='f-pass-security f-p'>
					<span>Seguridad de la contraseña:</span>
					<br />
					Utiliza 6 caracteres como mínimo. No utilices una contraseña de otro
					sitio ni un término que sea demasiado obvio, como el nombre de tu
					mascota.
				</p>
				<TextField
					error={
						errors.password_two != null ||
						(formState.touched.length === 2 && !values.passwords_equals)
					}
					color='secondary'
					name='password_two'
					className='f-form-input'
					id='f-passwordtwo-input'
					variant='outlined'
					type={values.show_secondPassword ? 'text' : 'password'}
					onChange={handleChange()}
					label='Confirma la nueva contraseña'
					ref={secondPass}
					helperText={
						errors.password_two && errors.password_two.type === 'required'
							? 'Una contraseña es requerida'
							: errors.password_two && errors.password_two.type === 'minLength'
							? 'La contraseña debe contener mínimo 6 caracteres'
							: errors.password_two && errors.password_two.type === 'maxLength'
							? 'La contraseña no debe exceder los 40 caracteres'
							: formState.touched.length === 2 &&
							  !values.passwords_equals &&
							  !values.passwords_equals &&
							  !values.passwords_equals
							? 'Las contraseñas deben coincidir'
							: ''
					}
					inputRef={register({
						required: true,
						minLength: constants.PASSWORD_MIN_LENGTH,
						maxLength: constants.PASSWORD_MAX_LENGTH,
					})}
					InputProps={{
						endAdornment: (
							<InputAdornment position='end'>
								<IconButton
									edge='end'
									aria-label='toggle password visibility'
									onClick={() => {
										handleClickShowPassword(2)
									}}
									onMouseDown={handleMouseDownPassword}
								>
									{values.show_secondPassword ? (
										<Icons.VisibilityOff className='f-btn-password' />
									) : (
										<Icons.Visibility className='f-btn-password' />
									)}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
				<div className='f-footer-changepass'>
					<Icon
						tagtype='span'
						onclick={type === 0 ? () => handlePrevSlider() : () => null}
						icon={`icon-arrow-left f-arrow-left ${
							type === 1 ? 'icon--hidden' : ''
						}`}
						size='1-2'
					/>
					{/* <ButtonLoading isEnabled={formState.touched.length === 0 || !formState.isValid || (formState.isValid && formState.touched.length === 1) || errors.password_two || errors.password_one} */}
					<ButtonLoading
						isEnabled={false}
						button={
							<Button
								id='f-changepass-btn'
								type='input'
								classname='f-button f-button--primary'
								text={convertText('CAMBIAR CONTRASEÑA')}
							/>
						}
						isShowingLoader={isLoaderVisible}
						bgClass='primary'
					/>
				</div>
			</form>
		</>
	)
}

export default ChangePassword
